import { useAppDisplayModeContext } from '@archipro-design/aria';
import { SearchFilterDesktop } from './SearchFilter.desktop';
import { SearchFilterMobile } from './SearchFilter.mobile';
import type { useSearchFilters } from '@modules/search/hook/use-search-filters';

export interface SearchFilterProp {
    filterDrawerOpen: boolean;
    toggleFilterDrawer: () => void;
    searchFilters: ReturnType<typeof useSearchFilters>;
    disableSort?: boolean;
    disableToggleFilter?: boolean;
    /** `revamp` renders the BC-4505 detail-page search-bar pill. */
    searchBarVariant?: 'default' | 'revamp';
    /** Flips the revamp search bar for the dark Projects tab. */
    searchBarTheme?: 'light' | 'dark';
    /** Placeholder for the revamp search input. */
    searchPlaceholder?: string;
    /**
     * The phone's field placeholder — "Search Products", "Search Projects" —
     * where the desktop one carries the professional's name and will not fit.
     */
    mobileSearchPlaceholder?: string;
    /** Drops the search input from the revamp bar (Projects tab). */
    hideSearch?: boolean;
    /**
     * Drops the sort dropdown from the revamp bar. Distinct from `disableSort`,
     * which greys the control out — and which the filter toggle also reads, so
     * it cannot be used to hide sort alone.
     */
    hideSort?: boolean;
    /**
     * How the filter toggle reads on the revamp bar: `pill` is the browse
     * pages' solid pill, `plain` is the icon + label alone, for tabs whose row
     * carries no other filled control.
     */
    filterControl?: 'pill' | 'plain';
    /**
     * "Display: {n}" column control, rendered beside Sort on the revamp bar.
     * The owning tab holds the column state, so tabs whose tiles are not a
     * uniform grid simply omit this. Ignored by the legacy bar.
     */
    displayControl?: React.ReactNode;
}

export const SearchFilter: React.FC<SearchFilterProp> = (props) => {
    const { desktop } = useAppDisplayModeContext();

    return !desktop ? (
        <SearchFilterMobile {...props} />
    ) : (
        <SearchFilterDesktop {...props} />
    );
};
